<nb-card [nbSpinner]="loading" nbSpinnerStatus="info">
  <nb-card-header>
    <button
      [ngClass]="menu == 'info' ? 'button-menu active' : 'button-menu'"
      [status]="menu == 'info' ? 'primary' : 'basic'"
      nbButton
      ghost
      nbTooltipPlacement="bottom"
      (click)="selectMenu('info')"
    >
      <nb-icon class="button-icon" icon="info-outline"></nb-icon>
      <span>{{ "common.info" | translate }}</span>
    </button>

    <button
      class="cancel"
      nbButton
      outline
      status="info"
      size="small"
      (click)="cancel()"
    >
      <nb-icon icon="close-outline"></nb-icon>
    </button>
  </nb-card-header>

  <nb-card-body>
    <form [formGroup]="diaForm">
      <div class="form-group">
        <label class="label">{{ "product.barcode" | translate }} </label>
        <input
          type="text"
          nbInput
          fullWidth
          class="form-control"
          placeholder="{{ 'product.barcode' | translate }}"
          formControlName="barcode"
          [(ngModel)]="product.barcode"
        />
      </div>

      <div class="form-group">
        <label for="inputTitle" class="label text-primary">{{
          "product.name" | translate
        }}</label>
        <input
          type="text"
          nbInput
          fullWidth
          class="form-control"
          placeholder="{{ 'product.name' | translate }}"
          id="title"
          formControlName="title"
          [(ngModel)]="title"
        />
      </div>

      <div class="form-group">
        <label for="inputUnitName" class="label text-primary"> ĐVT </label>
        <input
          type="text"
          nbInput
          fullWidth
          class="form-control"
          id="inputUnitName"
          formControlName="unitName"
          [(ngModel)]="product.unitName"
        />
      </div>

      <div class="form-group">
        <label class="label text-primary">
          {{ "product.price" | translate }}:
        </label>
        <input
          type="text"
          nbInput
          fullWidth
          class="form-control"
          placeholder="{{ 'product.price' | translate }}"
          id="price"
          formControlName="price"
          [(ngModel)]="product.price"
          [ngxNumberFormat]="formatCurrency"
        />
      </div>

      <div *ngIf="user.purchase" class="form-group">
        <label class="label text-primary">
          {{ "product.costPrice" | translate }}:
        </label>
        <input
          type="text"
          nbInput
          fullWidth
          class="form-control"
          placeholder="{{ 'product.costPrice' | translate }}"
          id="costPrice"
          formControlName="costPrice"
          [(ngModel)]="product.costPrice"
          [ngxNumberFormat]="formatCurrency"
        />
      </div>

      <div class="form-group">
        <div class="label">
          <label>{{ "common.note" | translate }}</label>
        </div>

        <textarea
          nbInput
          fullWidth
          rows="5"
          id="inputDescription"
          placeholder="{{ 'common.note' | translate }}"
          class="form-control"
          formControlName="description"
          [(ngModel)]="product.description"
        ></textarea>
      </div>
    </form>
  </nb-card-body>
  <nb-card-footer>
    <button
      type="submit"
      nbButton
      hero
      status="primary"
      size="small"
      [disabled]="submitted || !diaForm.valid"
      [class.btn-pulse]="submitted"
      (click)="submit(false)"
    >
      {{ "buttons.save" | translate }}
    </button>

    <button
      type="submit"
      nbButton
      hero
      status="success"
      size="small"
      [disabled]="submitted || !diaForm.valid"
      [class.btn-pulse]="submitted"
      (click)="submit(true)"
    >
      {{ "buttons.save" | translate }} & {{ "buttons.create" | translate }}
    </button>
  </nb-card-footer>
</nb-card>
